<!-- Alert -->

<template>
  <div class="alerta">
    <b-modal 
      v-model="snackbar"
      :title="titulo"
      ok-only
      no-close-on-backdrop no-close-on-esc 
      centered
    >
    <template v-slot:modal-header="{ close }">
        <h5 class="mb-0">{{ titulo }}</h5>
        <b-button size="sm" variant="outline-secondary" @click="close()">×</b-button>
    </template>

    {{ mensaje }}

    <template v-slot:modal-footer="{ ok, hide }">
      <b-button variant="outline-secondary" @click="cancelar()">Cancelar</b-button>
      <b-button variant="success" @click="ok()">Aceptar</b-button>
      <b-button variant="light" @click="hide('hide')">Ocultar</b-button>
    </template>
    </b-modal>    
  </div>
</template>

<script>
export default {
  data() {
    return {
      name: 'alerta',

      snackbar: false,
      titulo: "",
      mensaje: "",

      resolve: null,
      reject: null
    };
  },

  methods: {
    // muestro notificación
    open(arg, timeout = null) {
      console.log('** alerta.open',arg);
      //arg -> mensaje,titulo...

      if (!arg.mensaje) return;
      this.mensaje = arg.mensaje;

      this.titulo = (!arg.titulo ? 'ATENCIÓN' : arg.titulo);

      //botones -> btn:

      // temporizador o indifinido
      timeout ? setTimeout(this.close, timeout) : 0;

      this.snackbar = true;
    },

    // acepto promesa
    agree() {
      console.log("** alerta.agree");
      this.resolve(true);
      this.snackbar = false;
    },

    // NO acepto promesa
    cancelar() {
      console.log("** alerta.cancel");
      //this.resolve(false);
      this.snackbar = false;
      //this.$bvModal.hide()
    },

    // cierro notificación
    close() {
      console.log("** alerta.close");
      this.snackbar = false;
    }
  }
};
</script>
